import React, { useState } from "react";
import { SFIconButton, SFIcons, SFStack, SFUseStyled } from "@sf-core";

const { styled } = SFUseStyled();

const SFStackStyled = styled(SFStack)(({ theme }) => ({
  height: "100%",
  paddingLeft: theme.spacing(1),
}));

const CustomRadioCell = ({ node, api, onClick }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <SFStackStyled alignItems="center" justifyContent="center">
      <SFIconButton
        onClick={() => {
          // Call the onClick function to save the selected item
          onClick(node.data);
          // Apply 'remove' transaction
          const removeSkillTransaction = {
            remove: [node.data],
            route: node.data.category ? [node.data.category]: [node.data.jobFamilyName],
          };

          api.applyServerSideTransaction(removeSkillTransaction);
        }}
        onMouseOver={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        variant="transparent"
      >
        {hovered ? (
          <SFIcons.SFAddCircleIcon color="blue300" />
        ) : (
          <SFIcons.SFRadioButtonUncheckedIcon color="grey300" />
        )}
      </SFIconButton>
    </SFStackStyled>
  );
};

export default CustomRadioCell;